import { Link } from "react-router-dom";
import Layout from "../../hocs/Layout";

const Error404 = () => {
  return (
    <Layout>
      <main className="grid h-screen place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
        <div className="text-center">
          <p className="text-9xl font-semibold text-amber-600">404</p>
          <h1 className="mt-4 font-serif text-5xl font-semibold tracking-tight text-gray-900 sm:text-7xl">
            Page Not Found
          </h1>
          <p className="mt-6 font-medium text-lg text-gray-500 sm:text-xl">
            The page you are looking for may have been removed or is temporarily unavailable.
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <Link
              to="/"
              className="rounded-md bg-amber-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-amber-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-600"
            >
              Return Home
            </Link>
           
          </div>
        </div>
      </main>
    </Layout>
  );
};

export default Error404;
